<template>
  <div class="download_page" v-if="fileInfo">
    <div class="download">
      {{$t('view_download_index_173')}}:{{ fileName }}<br/>
      {{$t('view_download_index_174')}}:{{ (fileInfo.fileSize / 1024).toFixed(1) }}KB<br/>
      {{$t('view_download_index_175')}}:{{ fileType }}<br/>
      {{$t('view_download_index_176')}}:{{ fileInfo.createTime }}<br/>
      {{$t('view_download_index_177')}}: 
      <a :href="`javascript:download('${fileInfo.filePath}','${fileInfo.fileName}');`" target="_self">{{$t('view_download_index_178')}}</a>
      <a href="javascript:;" @click="copy">{{$t('view_download_index_179')}}</a>
    </div>
    <br/>
    <img v-if="fileType === $t('view_download_index_180')" :src="fileInfo.filePath">
    <video v-if="fileType === $t('view_download_index_181')" :src="fileInfo.filePath" controls></video>
  </div>
</template>

<script>
import i18n from '../../language/index'
export default {
  name: 'download',
  computed: {
    fileType () {
      let type = ''
      if (/(png|jpg|jpeg|gif)/ig.test(this.fileInfo.realFileFormat)) {
        type = i18n.t('view_download_index_180')
      } else if (/mp4/ig.test(this.fileInfo.realFileFormat)) {
        type = i18n.t('view_download_index_181')
      } else {
        type = i18n.t('view_download_index_182')
      }
      return type
    },
    fileName () {
      let fileName = this.fileInfo.fileName
      let suffix = fileName.substring(fileName.lastIndexOf(".") + 1, fileName.length)
      if (suffix !== this.fileInfo.realFileFormat) {
        this.fileInfo.fileName += `.${this.fileInfo.realFileFormat}`
      }
      return fileName
    }
  },
  data () {
    return {
      fileInfo: null
    }
  },
  mounted(){
    this.fileInfo = this.$route.query
    console.log(this.fileInfo.filePath)
    // 首次加载，等到首屏数据加载完毕，删除蒙层
    if ($('.init_mongolia_layer').length > 0) {
      $('.init_mongolia_layer').remove();
    }
  },
  methods: {
    copy () {
      window.prompt(i18n.t('view_download_index_183'), this.fileInfo.filePath)
    }
  }
}
</script>

<style lang="scss" scoped>
.download_page {
  padding: 8px;
  color: #000;
  .download {
    border: 1px solid #F4E190;
    background: #FFF6D0;
    text-align: left;
    font-size: 12px;
    line-height: 20px;
    padding-left: 10px;
    a {
      color: #0000ee;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/download/index.vue